import axios from "axios";
import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useProductApproval = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  const mutation = useMutation(
    ({ productId, status, reason }) =>
      axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/product/products/${productId}/approval`,
        { status, reason },
        { headers: { Authorization: `Bearer ${token}` } }
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("products");
        queryClient.invalidateQueries("productDetails");
      },
    }
  );

  return {
    reviewProduct: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  };
};

export default useProductApproval;
